import { render, staticRenderFns } from "./screenSplash.vue?vue&type=template&id=152e5a3d&scoped=true&"
import script from "./screenSplash.vue?vue&type=script&lang=js&"
export * from "./screenSplash.vue?vue&type=script&lang=js&"
import style0 from "./screenSplash.vue?vue&type=style&index=0&id=152e5a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e5a3d",
  null
  
)

export default component.exports